var installedModules = {};
var moduleToHandlerMapping = {
	72992: {
		getter: () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(67294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	80887: {
		getter: () => (__webpack_require__.e(3935).then(() => (() => (__webpack_require__(73935))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	13058: {
		getter: () => (__webpack_require__.e(2867).then(() => (() => (__webpack_require__(22867))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.4.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-use",
	},
	15330: {
		getter: () => (Promise.all([__webpack_require__.e(7009), __webpack_require__.e(3543)]).then(() => (() => (__webpack_require__(47009))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "30.2.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "ag-grid-react",
	},
	17159: {
		getter: () => (__webpack_require__.e(4372).then(() => (() => (__webpack_require__(94372))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.14.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	},
	23107: {
		getter: () => (Promise.all([__webpack_require__.e(1226), __webpack_require__.e(1993)]).then(() => (() => (__webpack_require__(31226))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.21.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@platform-ui-kit/components-library-react",
	},
	52213: {
		getter: () => (__webpack_require__.e(2682).then(() => (() => (__webpack_require__(2682))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.21.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@platform-ui-kit/components-library",
	},
	74961: {
		getter: () => (__webpack_require__.e(6317).then(() => (() => (__webpack_require__(25362))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ebay/nice-modal-react",
	},
	33543: {
		getter: () => (__webpack_require__.e(1731).then(() => (() => (__webpack_require__(81731))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "30.2.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "ag-grid-community",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"887": [
		80887
	],
	"2992": [
		72992
	],
	"3543": [
		33543
	],
	"7863": [
		13058,
		15330,
		17159,
		23107,
		52213,
		74961
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}